import { createContext, useContext } from 'react';

const WORKSPACE_POPOVER_PADDING = 10;

// The workspace area below the app header, or null outside a workspace
export const WorkspaceBoundaryContext = createContext<HTMLElement | null>(null);

/**
 * Opt-in popover positioning that keeps a Roma popover inside the workspace area, clear of the app header.
 * Spread the result onto the popover. Outside a workspace it falls back to React Aria's default (the document body).
 */
export const useWorkspacePopoverBoundary = () => {
    const boundaryElement = useContext(WorkspaceBoundaryContext);

    // React Aria skips positioning for a null boundary, so leave it undefined to keep its default
    if (!boundaryElement) return {};

    return { boundaryElement, containerPadding: WORKSPACE_POPOVER_PADDING };
};
